import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import { useNavigate, useLocation } from "react-router-dom";

import "./styles.css";

import { ReactComponent as OnlineWorld } from "../../assets/online-world.svg";

import StatusChip from "../../components/SmallComponents/StatusChip";
import MainButton from "../../components/SmallComponents/MainButton";
import Screen from "../../components/Screen";

import { useChallenge } from "../../contexts/ChallengeContext";

import {
  Snackbar,
  Divider,
  Typography,
  CircularProgress,
  Button,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  TextField,
  Modal,
  Alert,
  LinearProgress,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  styled,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import { ReactComponent as ExcelIcon } from "../../assets/custom-icons/excel.svg";

import SendIcon from "@mui/icons-material/Send";
import { DataGrid } from "@mui/x-data-grid";
import SendTimeExtensionIcon from "@mui/icons-material/SendTimeExtension";
import ShareIcon from "@mui/icons-material/Share";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import api from "../../helpers/api.js";

import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";

import { CreateModal } from "../Groups";

export default function CustomerImports() {
  document.title = "Importações | Ginastee";

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [editRecord, setEditRecord] = useState();

  const [pagination, setPagination] = useState({});

  const [filter, setFilter] = useState();

  const { currentChallenge, handleOpenAddUsersTool, Modal_addUserOpen } =
    useChallenge();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      handleLoadImports();
    }, 10);
  }, [pathname, currentChallenge]);

  useEffect(() => {
    handleLoadImports();
  }, [currentChallenge, filter, Modal_addUserOpen]);

  async function handleLoadImports(index = 1) {
    try {
      setLoading(true);

      let endpoint =
        "challenge/imports/getRecords?page=" +
        index +
        "&challenge_id=" +
        currentChallenge.challenge_id;

      if (filter) endpoint += endpoint + "&status=" + filter;

      let imports = await api.get(endpoint);

      imports = imports.data;

      setPagination({
        currentPage: imports.current_page,
        pages: imports.last_page,
      });

      imports = prepareRows(imports.data);

      if (imports) {
        setRows([...imports]);
      }

      setLoading(false);
    } catch (e) {
      window.setSnackbar(
        "Ocorreu um arro ao carrregar os usuários, por favor tente mais tarde"
      );
      setLoading(false);
    }

    function prepareRows(data) {
      data = data.map((row) => {
        row.created_at = formatDate(row.created_at);
        row.name = row.payload?.user?.name;
        row.email = row.payload?.user?.email;
        row.phone = row.payload?.user?.phone;

        row.statusColor = {
          error: "red",
          success: "green",
        }[row.status];

        row.error = row.result !== "sucesso" ? row.result : "";

        row.status = { error: "Falhou", success: "Sucesso" }[row.status];

        return row;
      });

      return data;

      function formatDate(date) {
        let dateTimeParts = date.split(" ");
        let dateParts = dateTimeParts[0].split("-"); // yyyy-mm-dd
        let timeParts = dateTimeParts[1]; // hh:mm:ss (se precisar, você pode incluir isso no formato final)

        let formattedDate =
          dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0];

        return formattedDate;
      }
    }
  }

  function handleOpenImportTool(data) {
    setEditRecord({ ...data });
    setEditModalOpen(true);
  }

  const columns = [
    {
      field: "id",
      headerName: "",
      sortable: false,
      renderCell: (params) => <div className="id-card">{params.row.id}</div>,
    },
    {
      field: "name",
      headerName: "Nome",
      sortable: false,
      flex: 1,
      minWidth: 100,
    },

    {
      field: "phone",
      headerName: "Celular",
      sortable: false,
      align: "right",
      headerAlign: "center",
      minWidth: 150,
    },
    {
      field: "email",
      headerName: "Email",
      sortable: false,
      align: "left",
      headerAlign: "center",
      minWidth: 280,
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      headerAlign: "center",
      renderCell: (params) => (
        <StatusChip label={params.row.status} color={params.row.statusColor} />
      ),
    },
    {
      field: "error",
      headerName: "Mensagem",
      sortable: false,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      renderCell: (params) => (
        <div>
          <Tooltip title="Editar envio" arrow>
            <IconButton
              size="small"
              disabled={params.row.status !== "Falhou"}
              onClick={(e) => {
                e.stopPropagation();
                console.log(params.row);
                handleOpenAddUsersTool({
                  name: params.row?.name,
                  email: params.row?.email,
                  phone: params.row?.phone,
                  fixImportRecordId: params.row?.id,
                });
              }}
              children={<EditIcon color="customBlue" />}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  function Pagination() {
    const items = [];

    for (let i = 1; i <= pagination.pages; i++) {
      items.push(<>{i}</>);
    }

    return (
      <div className="pagination-imports">
        {items.map((item, i) => (
          <Button
            disabled={loading}
            onClick={() => handleLoadImports(i + 1)}
            className={
              "pagination-button " +
              (i + 1 === pagination?.currentPage && "current-pagination-button")
            }
          >
            <Typography variant="h5">{item}</Typography>
          </Button>
        ))}
      </div>
    );
  }

  return (
    <Screen className="wl">
      <div className="mt-5">
        <Typography variant="h2" component="h2" className="left-border mt-4">
          Importação de participantes
        </Typography>
        <Typography variant="h4" component="h4" className="mt-2 fade mb-2">
          Adicione participantes ao sistema rapidamente importando uma planilha
        </Typography>
        <MainButton
          onClick={() => setImportModalOpen(true)}
          endIcon={<SendIcon color="primary" />}
          label="Importar usuários"
          color="primary"
        />
      </div>

      <FileImports />

      <div className="mt-4 pb-6">
        {loading ? (
          <CircularProgress
            thickness={5}
            color="secondary"
            className="loading-users"
          />
        ) : (
          <>
            <Box
              sx={{
                width: "100%",
                borderRadius: "20px",
                boxShadow: "0px 0px 30px -4px #d4d4d4",
                bgcolor: "background.paper",
              }}
              className="px-1 pb-2 pt-1"
            >
              <Typography variant="h3" className="px-1 mt-2 fade mb-2">
                Histórico de registros importados
              </Typography>
              <div className="filter-row px-1 pt-2">
                <Typography variant="h5">Filtrar por status:</Typography>
                <Button
                  className="filter-btn"
                  color="success"
                  variant={filter === "success" ? "contained" : "outlined"}
                  onClick={() => {
                    if (filter === "success") setFilter(null);
                    else setFilter("success");
                  }}
                >
                  Apenas sucesso
                </Button>
                <Button
                  className="filter-btn"
                  color="error"
                  variant={filter === "error" ? "contained" : "outlined"}
                  onClick={() => {
                    if (filter === "error") setFilter(null);
                    else setFilter("error");
                  }}
                >
                  Apenas com erro
                </Button>
              </div>
              <DataGrid
                disableSelectionOnClick
                className="mt-4"
                color="secondary"
                disableColumnMenu={true}
                hideFooter={true}
                autoHeight
                rows={rows}
                columns={columns}
                getRowId={(row) => row?.id}
                components={{
                  NoRowsOverlay: () => (
                    <Typography
                      style={{
                        textAlign: "center",
                      }}
                      height="100%"
                      alignItems="center"
                      className="px-2 py-4"
                      justifyContent="center"
                    >
                      Nenhuma importação foi encontrada
                    </Typography>
                  ),
                }}
              />
            </Box>
          </>
        )}
      </div>

      <ImportFileModal open={importModalOpen} setOpen={setImportModalOpen} />

      <Pagination />
    </Screen>
  );
}

const ImportFileModal = ({ open, setOpen }) => {
  const [fileData, setFileData] = useState();
  const [error, setError] = useState();
  const [headers, setHeaders] = useState();
  const [processingFile, setProcessingFile] = useState(false);
  const initialFieldMapConfig = {
    email: "",
    phone: "",
    username: "",
    groups: "",
  };
  const [fieldMap, setFieldMap] = useState({ ...initialFieldMapConfig });
  const [loading, setLoading] = useState(false);

  const fieldMappingConfig = [
    {
      key: "username",
      label: "Nome Completo",
    },
    {
      key: "email",
      label: "E-mail",
    },
    {
      key: "phone",
      label: "Número de celular",
    },
    {
      key: "groups",
      label: "Grupo (opcional)",
    },
  ];

  const [groupsMap, setGroupsMap] = useState({});
  const { groups, currentChallenge } = useChallenge();

  const [step, setStep] = useState("IMPORT");

  const fileObj = useRef();

  const initialFieldsMatchDone = useRef(false);
  const initialGroupsMatchDone = useRef(false);

  useEffect(() => {
    if (!fileData) {
      setHeaders(null);
      setFieldMap({ ...initialFieldMapConfig });
    } else {
      if (!processingFile && headers) {
        setStep("FIELD_MAP");
      }
    }
  }, [fileData, processingFile, headers]);

  useEffect(() => {
    setTimeout(() => {
      setError(null);
    }, 8000);
  }, [error]);

  async function handleImportUsers() {
    if (!fileData) {
      setError("Faça o upload de um arquivo Excel antes de prosseguir");
      return;
    }

    if (!fieldMap.email || !fieldMap.phone || !fieldMap.username) {
      setError("Realize o mapeamento de campos antes de prosseguir");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", fileData);
      formData.append("challenge_id", currentChallenge.challenge_id);
      formData.append("fieldMap[email]", fieldMap.email);
      formData.append("fieldMap[phone]", fieldMap.phone);
      formData.append("fieldMap[username]", fieldMap.username);
      formData.append("fieldMap[group]", fieldMap.groups);
      formData.append("groupMap", JSON.stringify(groupsMap));

      const result = await api.post("/challenge/members/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (result.data.success) {
        window.setSnackbar("Usuários em importação");
        setTimeout(() => window.navigate("/imports"), 2000);
        setOpen(false);
      } else {
        window.setSnackbar(
          "Houve um erro inesperado ao importar os participantes, verifique o arquivo e tente novamente"
        );
      }
    } catch (e) {}

    setLoading(false);
  }

  function UploadFileDropArea() {
    const onDrop = useCallback(
      (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
          onFileAccepted(acceptedFiles[0]);
        }
      },
      [onFileAccepted]
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      maxFiles: 1,
    });

    function onFileAccepted(file) {
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        window.setSnackbar("Insira um arquivo .xlsx (Excel) para prosseguir");
        return;
      }

      const reader = new FileReader();

      setProcessingFile(true);

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        fileObj.current = json;

        initialFieldsMatchDone.current = false;
        initialGroupsMatchDone.current = false;

        setHeaders(Object.keys(json[0]));
        setProcessingFile(false);
      };

      reader.readAsArrayBuffer(file);

      setFileData(file);
    }

    return (
      <>
        <div className="mb-1 input-file-area import-area" {...getRootProps()}>
          <input {...getInputProps()} />

          <ExcelIcon />
          <Typography variant="body1">
            {isDragActive
              ? "Solte o arquivo aqui"
              : "Arraste e solte um arquivo aqui, ou clique para selecionar o arquivo"}
          </Typography>
        </div>
        <Typography
          variant="small"
          className="mt-1"
          style={{
            color: "#444",
          }}
        >
          Formatos permitidos: .xlsx (excel)
        </Typography>
      </>
    );
  }
  function LoadedFile() {
    return (
      <div className="uploaded-file">
        <ExcelIcon className="excel-icon" />
        <Typography variant="small">{fileData.name}</Typography>
        <IconButton
          style={{ padding: "6px" }}
          className="remove-file"
          onClick={() => {
            setStep("IMPORT");
            setHeaders(null);
            setFieldMap({ ...initialFieldMapConfig });
          }}
        >
          <CloseIcon style={{ width: "16px", height: "16px" }} />
        </IconButton>
      </div>
    );
  }
  function FieldMapping() {
    useEffect(() => tryToMatchFields(), []);

    function tryToMatchFields() {
      if (initialFieldsMatchDone.current) return;

      initialFieldsMatchDone.current = true;

      const initialMatch = {};

      fieldMappingConfig.forEach((fieldConfig) => {
        const matchId = headers.filter(
          (header) => fieldConfig.label.toLowerCase() === header?.toLowerCase()
        )[0];

        if (matchId) initialMatch[fieldConfig.key] = matchId;
      });

      setFieldMap({ ...initialMatch });
    }

    return (
      <div className="field-mapping-area mt-4">
        <Typography variant="body1">Realize o mapeamento de campos</Typography>
        <Typography variant="small">
          Informe ao sistema quais colunas do arquivo importado correspondem aos
          campos do usuário
        </Typography>

        {fieldMappingConfig.map((field, i) => (
          <div className="field-row mt-2">
            <Typography variant="small">{field.label}</Typography>
            <div className="connection-row"></div>
            <Select
              onChange={(v) =>
                setFieldMap({ ...fieldMap, [field.key]: v.target.value })
              }
              value={fieldMap[field.key]}
              displayEmpty
              placeholder="ddd"
              style={{ maxWidth: "330px !important", width: "100%" }}
              size="small"
              className="row-item-grow"
            >
              <MenuItem disabled value="">
                <>Selecione a coluna correspondente</>
              </MenuItem>
              {headers.map((header) => (
                <MenuItem className="menu-option" value={header}>
                  {header}
                </MenuItem>
              ))}
            </Select>
          </div>
        ))}
      </div>
    );
  }
  function GroupsMapping() {
    let groupsUnique = fileObj.current.map((row) => row[fieldMap.groups]);
    groupsUnique = [...new Set(groupsUnique)];
    console.log(groupsUnique);

    const [createGroupModalOpen, setCreateGroupModalOpen] = useState(false);

    useEffect(() => {}, [groups]);

    useEffect(() => tryToMatchFields(), []);

    function onNewGroupCreated(newGroupId) {
      setGroupsMap({ ...groupsMap, [createGroupModalOpen]: newGroupId });
      setCreateGroupModalOpen(false);
    }
    function tryToMatchFields() {
      if (initialGroupsMatchDone.current) return;

      initialGroupsMatchDone.current = true;

      const initialMatch = {};

      groupsUnique.forEach((fileGroupName) => {
        const matchId = groups.filter(
          (group) => group.name.toLowerCase() === fileGroupName?.toLowerCase()
        )[0]?.id;

        if (matchId) initialMatch[fileGroupName] = matchId;
      });

      setGroupsMap({ ...initialMatch });
    }

    return (
      <>
        <Typography variant="body1" className="mb-1">
          Por último, correlacione os grupos da planilha com os grupos
          existentes no sistema
        </Typography>
        <Divider />
        <div className="modal-legend-header mt-2 mb-1 pl-1 pr-3">
          <Typography variant="small">Grupo na planilha</Typography>
          <Typography variant="small">Grupo no sistema</Typography>
        </div>

        <div className="map-groups px-1">
          {groupsUnique.map((field, i) => (
            <div className="field-row mt-2">
              <Typography variant="small">
                {field || <i>Usuários sem grupo</i>}
              </Typography>
              <div className="connection-row"></div>
              <Select
                onChange={(v) =>
                  setGroupsMap({ ...groupsMap, [field]: v.target.value })
                }
                value={groupsMap[field] || ""}
                displayEmpty
                placeholder="ddd"
                style={{ minWidth: "200px" }}
                size="small"
                className="row-item-grow"
              >
                <MenuItem value="">
                  <i>Manter sem grupo</i>
                </MenuItem>
                {groups.map((group) => (
                  <MenuItem className="menu-option" value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
              </Select>
              <Tooltip arrow title="Criar grupo">
                <MainButton
                  onClick={() => setCreateGroupModalOpen(field)}
                  label="Criar grupo"
                  color="white"
                  endIcon={<AddIcon />}
                  shadow={false}
                  disabled={
                    groups?.map((group) => group.name).includes(field) || !field
                  }
                  children={<AddIcon />}
                />
              </Tooltip>
            </div>
          ))}
        </div>

        <CreateModal
          open={!!createGroupModalOpen}
          setOpen={setCreateGroupModalOpen}
          defaultName={createGroupModalOpen}
          onCreated={onNewGroupCreated}
        />
      </>
    );
  }
  function Tutorial() {
    return (
      <div className="tutorial-import mb-2">
        <Typography variant="body1" style={{ color: "var(--secondary-800)" }}>
          O que acha de montar uma planilha já formatada?
        </Typography>
        <Typography variant="span">
          Baixe o <>arquivo modelo abaixo</>, e a complete com os dados dos
          participantes
        </Typography>
        <MainButton
          className="pt-1"
          onClick={() => {
            const fileUrl = "/import_template.xlsx";
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = "import_template.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
          label="Baixar arquivo modelo"
          color="primary"
          endIcon={<FileDownloadIcon color="primary" />}
          shadow={false}
        />
      </div>
    );
  }

  const currentStepComponent = {
    IMPORT: (
      <div className="mb-4">
        <Tutorial />
        <UploadFileDropArea />
      </div>
    ),
    FIELD_MAP: (
      <>
        <LoadedFile />
        <FieldMapping />
        <LoadingButton
          loading={loading}
          fullWidth
          variant="contained"
          className="mt-4 submit-main-btn"
          onClick={
            fieldMap.groups
              ? () => {
                  if (
                    !fieldMap.email ||
                    !fieldMap.phone ||
                    !fieldMap.username
                  ) {
                    setError("Finalize o mapeamento para prosseguir");
                    return;
                  }
                  initialGroupsMatchDone.current = false;
                  setStep("GROUPS_MAP");
                }
              : handleImportUsers
          }
        >
          {fieldMap.groups ? "Ir para o próximo passo" : "Importar usuários"}
        </LoadingButton>
        <Button
          fullWidth
          className="mt-1 mb-2 py-1"
          onClick={() => setOpen(false)}
        >
          Cancelar
        </Button>
      </>
    ),
    GROUPS_MAP: (
      <>
        <GroupsMapping />
        <LoadingButton
          loading={loading}
          fullWidth
          variant="contained"
          className="mt-4 submit-main-btn"
          onClick={handleImportUsers}
        >
          Importar usuários
        </LoadingButton>
        <Button
          fullWidth
          className="mt-1 mb-2 py-1"
          onClick={() => setStep("FIELD_MAP")}
        >
          Voltar
        </Button>
      </>
    ),
  }[step];

  return (
    <Modal open={open}>
      <div className="modal-content modal-import">
        <div className="px-3 py-2 modal-header">
          <Typography variant="h4">Importar usuários em massa</Typography>
          <IconButton onClick={() => setOpen(false)} children={<CloseIcon />} />
        </div>
        <Divider />
        {processingFile ||
          (loading && (
            <LinearProgress color="success" variant="indeterminate" />
          ))}

        <div className="px-3 pt-4 pb-2">
          {error && (
            <Alert severity="error" className="mb-3">
              {error}
            </Alert>
          )}

          {currentStepComponent}
        </div>
      </div>
    </Modal>
  );
};

const FileImports = () => {
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);

  const { currentChallenge, Modal_addUserOpen } = useChallenge();

  useEffect(() => {
    if (loading) handleLoadRecords();
  }, [loading]);

  useEffect(() => {
    const subs = setInterval(() => {
      handleLoadRecords();
    }, 5000);
    return () => clearInterval(subs);
  }, []);

  console.log("Records", records);

  useEffect(() => {
    if (!Modal_addUserOpen) setLoading(true);
  }, [Modal_addUserOpen, currentChallenge]);

  const currentChallengeId = currentChallenge?.challenge_id;

  async function handleLoadRecords() {
    try {
      let endpoint =
        "challenge/imports/getStatuses?challenge_id=" + currentChallengeId;

      let imports = await api.get(endpoint);

      setRecords([...imports.data]);
    } catch (e) {
      window.setSnackbar(
        "Ocorreu um arro ao carrregar os usuários, por favor tente mais tarde"
      );
    }
    setLoading(false);
  }

  const columns = [
    {
      field: "id",
      headerName: "",
      sortable: false,
      renderCell: (params) => <div className="id-card">{params.row.id}</div>,
    },
    {
      field: "estimated_total",
      headerName: "Total",
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "records_created",
      headerName: "Importados",
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "file",
      headerName: "Arquivo",
      sortable: false,
      align: "right",
      headerAlign: "center",
      minWidth: 250,
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="uploaded-file">
            <ExcelIcon className="excel-icon" />
            <Typography
              variant="small"
              style={{ flexGrow: 1, textWrap: "nowrap", textOverflow: "eli" }}
            >
              {params.row.file}
            </Typography>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      sortable: false,
      headerAlign: "center",
      renderCell: (params) => {
        let currProgress = Math.floor(
          (params.row.records_created / params.row.estimated_total) * 100
        );

        if (currProgress > 100) currProgress = 100;

        const date = new Date(
          params.row.last_record_created_at.replace(" ", "T")
        );
        const now = new Date();
        const differenceInMs = now - date;
        const differenceInHours = differenceInMs / (1000 * 60 * 60);
        const completed = differenceInHours > 1 || currProgress === 100;

        if (completed)
          return <span className="status-chip green">Completo</span>;

        return (
          <div className="curr-status">
            <Box sx={{ width: "100%" }}>
              <LinearProgress
                variant="buffer"
                color="primary"
                value={currProgress}
                valueBuffer={currProgress}
                style={{ borderRadius: "8px" }}
              />
            </Box>
            <Typography variant="label" className="pl-1">
              {currProgress}%
            </Typography>
          </div>
        );
      },
    },
  ];

  return (
    <div className="file-imports-status">
      <Typography variant="h3" className="pb-1 mt-3">
        Arquivos importados
      </Typography>
      {!loading && records && (
        <DataGrid
          disableSelectionOnClick
          className="mt-1"
          color="secondary"
          disableColumnMenu={true}
          hideFooter={true}
          density="compact"
          autoHeight
          rows={records}
          columns={columns}
          getRowId={(row) => row?.id}
        />
      )}
    </div>
  );
};

export { ImportFileModal };
